import { Image, Label, Option } from './styles';
import { AutocompleteSelectorOptionWithImageProps } from './props';

/**
 * A component that renders an autocomplete selector option with an image and label
 *
 * @param {Object} props - The component props
 * @param {string} props.image - The URL of the image to display
 * @param {string} props.label - The text label to display
 * @param {boolean} props.selected - Whether this option is currently selected
 * @param {Function} props.handleSelect - Callback function when option is selected
 * @param {T} props.option - The option data/value to pass to handleSelect
 * @returns {JSX.Element} A clickable option with image and label
 * @template T - The type of the option value
 */
export function AutocompleteSelectorOptionWithImage<T>({
  image,
  label,
  selected,
  handleSelect,
  option,
}: AutocompleteSelectorOptionWithImageProps<T>) {
  return (
    <Option selected={selected} onClick={() => handleSelect(option)}>
      <Image
        src={image}
        alt={`label-${label}`}
        format="square"
        width={32}
        height={32}
        secondarySkeleton
      />
      <Label>{label}</Label>
    </Option>
  );
}
